import { useEffect, useCallback } from 'react'
import { useToast } from 'hooks'

export const useMutation = (callback, { success, error, dispatch: dispatches, trigger }) => {
    const { toast } = useToast()

    const [action, { status, ...result }] = callback()

    const handleDispatch = useCallback(
        dispatches => {
            dispatches.forEach(element => {
                const { dispatch, actions } = element
                actions.forEach(e => {
                    dispatch(e)
                })
            })
        },
        [dispatches]
    )

    const handleTrigger = useCallback(
        dispatches => {
            dispatches.forEach(element => {
                const { dispatch, actions } = element
                actions.forEach(e => {
                    dispatch(e)
                })
            })
        },
        [trigger]
    )

    useEffect(() => {
        if (status === 'fulfilled') {
            success && toast.success(success)
            dispatches && handleDispatch(dispatches.filter(d => !d.when || d.when === 'success'))
            trigger && handleTrigger(trigger.filter(t => !t.when || t.when === 'success'))
        }
        if (status === 'rejected') {
            error && toast.error(error)
            dispatches && handleDispatch(dispatches.filter(d => d.when === 'error'))
            trigger && handleTrigger(trigger.filter(t => t.when === 'error'))
        }
    }, [status])

    return [action, { status, ...result }]
}
